/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferCustomersControllerListCustomersQueryResponse, TransferCustomersControllerListCustomersQueryParams, TransferCustomersControllerListCustomers401, TransferCustomersControllerListCustomers403 } from "../../models/transferCustomersController/TransferCustomersControllerListCustomers";

function getTransferCustomersControllerListCustomersUrl() {
  const res = { method: 'GET', url: `/api/v1/transfer-customers` as const }  
  return res
}

/**
 * @summary List customers available for transfer from 1.0 database
 * {@link /api/v1/transfer-customers}
 */
export async function transferCustomersControllerListCustomers(params?: TransferCustomersControllerListCustomersQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TransferCustomersControllerListCustomersQueryResponse, ResponseErrorConfig<TransferCustomersControllerListCustomers401 | TransferCustomersControllerListCustomers403>, unknown>({ method : "GET", url : getTransferCustomersControllerListCustomersUrl().url.toString(), params, ... requestConfig })  
  return res.data
}